import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import { MainButton } from 'components/button'

import styles from './well_done.scss'

import wellDoneSvg from 'assets/views/slides/activities/mp-well-done.svg'

class WellDone extends PureComponent {

	render() {
		return (
			<Modalizer closeAction={this.props.closeHandler}>
				<div styleName='popup-standard'>
					<div styleName='popup-standard-icon'>
						<Isvg src={wellDoneSvg} cacheGetRequests={true} />
					</div>
					<h1 styleName='popup-standard-title'>{this.props.title}</h1>
					<p styleName='popup-standard-attempts'>{this.props.attempts} {localize('matchingPairs_wellDone_tries')}</p>
					<p styleName='popup-standard-text'>{this.props.text}</p>
					<div styleName='popup-standard-button'>
						<MainButton onMouseDown={this.props.buttonHandler}>
							{this.props.buttonText}
						</MainButton>
					</div>
				</div>
			</Modalizer>
		)
	}

}

WellDone.propTypes = {
	closeHandler: PropTypes.func,
	title: PropTypes.string,
	attempts: PropTypes.number,
	text: PropTypes.string,
	buttonHandler: PropTypes.func,
	buttonText: PropTypes.string,
}

export default CSSModules(WellDone, styles, {allowMultiple: true})
